/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsDroplet: {
  name: 'droplet';
  data: string;
} = {
  name: 'droplet',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.214 1.727a.378.378 0 0 0-.428 0c-.699.463-2.037 1.431-3.195 2.726C3.424 5.757 2.5 7.326 2.5 9a5.5 5.5 0 1 0 11 0c0-1.674-.924-3.243-2.09-4.547-1.16-1.295-2.497-2.263-3.196-2.726Zm-.98-.834a1.378 1.378 0 0 1 1.532 0c.733.487 2.15 1.509 3.389 2.894C13.385 5.163 14.5 6.964 14.5 9a6.5 6.5 0 1 1-13 0c0-2.036 1.115-3.837 2.345-5.213C5.084 2.402 6.501 1.38 7.234.893Z" fill="currentColor"/></svg>`,
};
